import * as React from 'react';
import { Hr, Paragraph } from '../../../../elements';
import TwoColRow from './TwoColRow';
const CohabitantsRow = ({ value, i18n, formatDate }) => (React.createElement(React.Fragment, null,
    value.cohabitants.length !== 0 ? (React.createElement(React.Fragment, null,
        value.cohabitants.length !== 0 &&
            value.cohabitants.map((item, index) => (React.createElement(React.Fragment, { key: index },
                React.createElement(TwoColRow, { label: i18n('common.fullName'), value: item.fullName }),
                React.createElement(TwoColRow, { label: i18n('common.yearOfBirth'), value: item.yearOfBirth }),
                React.createElement(TwoColRow, { label: i18n('common.description'), value: item.description }),
                React.createElement("br", null)))),
        React.createElement(Hr, null),
        React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('stateauthority.taxAgency')} (${formatDate(value.verificationDate)}` }))) : (React.createElement(Paragraph, null, i18n('common.noCohabitants'))),
    value.comment != '' && (React.createElement("div", { className: 'ReadReportContent__Notation ReadReportContent__Space--large' },
        React.createElement(Paragraph, { bold: true }, i18n('common.note')),
        React.createElement("div", { className: 'ReadReportContent__NotationContent' },
            React.createElement(Paragraph, { className: 'ReadReportContent__Space--semi-medium ReadReportContent__Space--scroll-overflow' }, value.comment))))));
export default CohabitantsRow;
